export default __webpack_public_path__ + "static/Scott.RumphCHAIRFundraising_social-690d212aa63648d396fcfb7bcc0684e7.jpg";